import Ruble from '../icons/currencies/ruble';
import Dollar from '../icons/currencies/dollar';
import Euro from '../icons/currencies/euro';

export const accountsData = [
  {
    moneyAmount: '19 842,7',
    currency: '₽',
    cardName: 'Pirozhkoff Gold',
    icon: <Ruble />,
  },
  {
    moneyAmount: '0,67',
    currency: '$',
    cardName: 'Pirozhkoff Gold USD',
    icon: <Dollar />,
  },
  {
    moneyAmount: '0',
    currency: '€',
    cardName: 'Pirozhkoff Gold EUR',
    icon: <Euro />,
  },
];

export const expensesData = [
  {
    date: 'Today',
    list: [
      {
        icon: 'bg-[url(https://brands-prod.cdn-tinkoff.ru/general_logo/eda-yandex.png)]',
        account: 'Debit card',
        organization: 'Яндекс.Еда',
        amount: '-3,00',
      },
      {
        icon: 'bg-[url(https://brands-prod.cdn-tinkoff.ru/general_logo/eda-yandex.png)]',
        account: 'Debit card',
        organization: 'Яндекс.Еда',
        amount: '-807,00',
      },
      {
        icon: 'bg-[url(https://brands-prod.cdn-tinkoff.ru/general_logo/eda-yandex.png)]',
        account: 'Debit card',
        organization: 'Яндекс.Еда',
        amount: '+360,00',
        date: '14.05.2023',
      },
    ],
  },
  {
    date: 'Yesterday',
    list: [
      {
        icon: 'bg-[url(https://brands-prod.cdn-tinkoff.ru/general_logo/rusalka.png)]',
        account: 'Debit card',
        organization: 'РусАлка',
        amount: '-37,99',
      },
    ],
  },
  {
    date: '6.05.2023',
    list: [
      {
        icon: 'bg-[url(https://brands-prod.cdn-tinkoff.ru/general_logo/tinkoff.png)]',
        account: 'Tinkoff Black',
        organization: 'Карина Т.',
        amount: '-790,00',
      },
    ],
  },
];

export const usersList = [
  {
    id: 'dSljkfDhvSCir23d98hJ32d',
    first_name: 'Maruf',
    last_name: 'Asatullaev',
    joined_date: '12.03.2019',
    email: 'marufLovesC4rs@gmail.com',
    phone: '79863942247',
    hashed_password: 'aWxpa2VhbmltZQ==',
    inn: '8495738667440',
    snils: '77055948339764',
    role: 'base',
  },
  {
    id: 'asdjlRFvhjn43cNiu2w3yh289',
    first_name: 'Erzhan',
    last_name: 'Prosypaysya',
    joined_date: '12.12.2012',
    email: 'yaPr0snulsy4@gmail.com',
    phone: '79963455455',
    hashed_password: 'ZXJ6aGFub3phdnJvc2V2cw==',
    inn: '123456789012',
    snils: '12345678901234',
    role: 'employee',
  },
  {
    id: 'cjfdbncjHfnvkHJFkvrci47=3d',
    first_name: 'Dima',
    last_name: 'Pirozhkoff',
    joined_date: '23.01.2013',
    email: 'dimaseek33@gmail.com',
    phone: '78452332996',
    hashed_password: 'ZXJ6aGFub3phdnJvc2V2cw==',
    inn: '349845155742',
    snils: '57384930672811',
    role: 'admin',
  },
  {
    id: 'viufhHdfoJgvX57cv40vcl=jeh',
    first_name: 'Tasha',
    last_name: 'Sakovets',
    joined_date: '29.02.2016',

    email: 'w00ffre4k@gmail.com',
    phone: '79993090919',
    hashed_password: 'aWxvdmFjYXRzcHVycg==',
    inn: '825946108739',
    snils: '42746945611274',
    role: 'employee',
  },
  {
    id: 'hfieuhDkgeJ45IDhg=fjk',
    first_name: 'Karina',
    last_name: 'Tyulebaewa',
    joined_date: '28.10.2015',

    email: 'volny666@gmail.com',
    phone: '79961440513',
    hashed_password: 'aWxvdmFteXNlbGY=',
    inn: '098765432184',
    snils: '48296733904552',
    role: 'employee',
  },
];
